import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import {
  APP_NAME,
  DEV_PARTNER_NAME,
  DEV_PARTNER_URL,
} from '../../constants/brand';

export type PartnerRole = 'technology' | 'develop';

interface PlatformFooterProps {
  /** Light text on dark backgrounds */
  light?: boolean;
  align?: 'left' | 'center' | 'right';
  /** Auth / app: Technology Partner · Home landing: Develop partner */
  partnerRole?: PartnerRole;
  sx?: object;
}

const partnerPhrase = (role: PartnerRole) =>
  role === 'develop' ? 'Develop partner' : 'Technology Partner';

/** Copyright + partner credit */
export const PlatformFooter: React.FC<PlatformFooterProps> = ({
  light = false,
  align = 'center',
  partnerRole = 'technology',
  sx = {},
}) => {
  const muted = light ? 'rgba(255,255,255,0.42)' : '#64748b';
  const link = light ? 'rgba(255,255,255,0.72)' : '#6221d6';

  return (
    <Typography
      component="footer"
      sx={{
        fontSize: 11,
        lineHeight: 1.5,
        color: muted,
        textAlign: align,
        ...sx,
      }}
    >
      © {new Date().getFullYear()} {APP_NAME}
      {' '}and {partnerPhrase(partnerRole)}{' '}
      <Link
        href={DEV_PARTNER_URL}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{ color: link, fontWeight: 600, fontSize: 'inherit' }}
      >
        {DEV_PARTNER_NAME}
      </Link>
    </Typography>
  );
};

/** Compact footer bar for authenticated app shell (once per page) */
export const AppShellFooter: React.FC = () => (
  <Box
    component="footer"
    sx={{
      mt: 'auto',
      px: { xs: 1.5, sm: 2, md: 3 },
      py: 1.25,
      borderTop: '1px solid',
      borderColor: 'divider',
      bgcolor: 'transparent',
    }}
  >
    <PlatformFooter align="center" partnerRole="technology" />
  </Box>
);
